export default __webpack_public_path__ + "static/media/BWP ZOO WEB ICON parrot house CY.7539ff9b.png";